import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_48: FaireProductEntity = {
  token: "starter_collection_48",
  type: "product",
  name: "Canyon Instant Coffee",
  brandName: "Canyon Coffee",
  imageUrl: "",
  priceDollars: 18,
  msrpDollars: 36,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
